/* Terms & Conditions checkout gate - behaviour for snippets/rk-terms-gate.liquid (the why is documented there).
   Loaded once with the page by snippets/cart-drawer.liquid and sections/main-cart-footer.liquid, OUTSIDE the markup
   Dawn re-renders. A <script> inside re-rendered markup never runs: when the page loaded with an empty cart and the
   first item was added from a product page, the gate arrived without its script and the checkout button stayed
   locked for good (2026-09-15). */
(function () {
  if (window.rkTermsGateInit) return;
  var KEY = 'rk.terms.accepted';
  function remembered() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function remember(ok) { try { sessionStorage.setItem(KEY, ok ? '1' : '0'); } catch (e) { /* private mode */ } }

  function init(gate) {
    var input = gate.querySelector('.rk-terms__input');
    if (!input) return;
    // already wired: re-apply, in case the button was re-rendered without this gate
    if (gate.dataset.ready === '1') { if (gate.rkApply) gate.rkApply(false); return; }
    var hidden = gate.querySelector('.rk-terms__attr');
    var notice = gate.querySelector('.rk-terms__notice');
    function button() { return document.getElementById(gate.dataset.button); }
    function apply(touched) {
      var ok = input.checked;
      var b = button();
      if (hidden) hidden.value = ok ? (hidden.value || new Date().toISOString()) : '';
      if (b) {
        // Sweden + Hard Kombucha in the cart keeps the button locked whatever the box says (assets/rk-hard-se.js)
        var locked = !ok || !!(window.rkCheckoutBlocked && window.rkCheckoutBlocked(b));
        b.disabled = locked;
        b.setAttribute('aria-disabled', String(locked));
        b.classList.toggle('rk-terms--locked', locked);
        // a disabled button swallows clicks; catch the attempt on its wrapper and explain
        var ctas = b.closest('.cart__ctas') || b.parentElement;
        if (ctas && !ctas.dataset.rkTermsBound) {
          ctas.dataset.rkTermsBound = '1';
          ctas.addEventListener('click', function () {
            var cur = button();
            if (cur && cur.disabled && !input.checked) { if (notice) notice.hidden = false; input.focus(); }
          });
        }
      }
      if (notice) notice.hidden = ok || !touched;
    }
    gate.dataset.ready = '1';
    gate.rkApply = apply;
    // a tick made before this script ran counts; otherwise restore the choice from this session
    if (input.checked) remember(true); else input.checked = remembered();
    apply(false);
    input.addEventListener('change', function () {
      remember(input.checked);
      apply(true);
      // the cart page and the drawer each carry a gate - keep them in step
      document.dispatchEvent(new CustomEvent('rk:terms', { detail: { ok: input.checked, from: gate } }));
    });
    document.addEventListener('rk:terms', function (e) {
      if (e.detail.from === gate || !gate.isConnected) return;
      input.checked = e.detail.ok;
      apply(false);
    });
  }

  function initAll() { document.querySelectorAll('rk-terms-gate').forEach(init); }
  window.rkTermsGateInit = initAll;
  // 1) first paint; 2) every cart change (Dawn replaces the drawer/cart markup); 3) any render that bypasses pub/sub
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true }); else initAll();
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(initAll, 0); });
  }
  var pending = 0;
  new MutationObserver(function () { if (!pending) pending = setTimeout(function () { pending = 0; initAll(); }, 50); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
